import React from 'react';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nitzan-light-bg via-white to-nitzan-sage/10">
      <div className="pt-20">
        <ContactSection />
      </div>
    </div>
  );
};

export default ContactPage;

